import { defineSlotRecipe } from "@pandacss/dev";

const slots = ["content", "backdrop", "positioner", "footer"];

export const aromaDialog = defineSlotRecipe({
  className: "aroma-dialog",
  jsx: ["Dialog"],
  slots,
  base: {
    backdrop: {
      position: "fixed",
      top: "0",
      left: "0",
      bottom: "0",
      right: "0",
      height: "100%",
      width: "100%",
      backdropFilter: "blur(4px)",
      zIndex: "var(--backdrop-z-index)",
      _open: {
        animation: "fadeIn 0.25s ease-in",
      },
      _close: {
        animation: "fadeOut 0.2s ease-out",
      },
      pointerEvents: "all",
    },
    positioner: {
      position: "fixed",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "var(--dialog-z-index)",
      pointerEvents: "none",
    },
    content: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: "var(--dialog-gap)",
      maxHeight: "var(--dialog-max-height)",
      width: "var(--dialog-width)",
      padding: "padding.6",
      margin: "auto 24px",
      background: "background.neutral.base.subtlest",
      boxShadow: "effect.shadow.bolder-bottom",
      borderRadius: "2xl",
      _open: {
        animation: "fadeIn 0.25s ease-in, slide-in-top-subtle 0.3s ease-in-out",
      },
      _close: {
        animation:
          "fadeOut 0.25s ease-out, slide-out-top-subtle 0.3s ease-in-out",
      },
      '& [data-part="title"]': {
        textStyle: "title.m",
        color: "content.neutral.base.bold",
      },
      '& [data-part="description"]': {
        display: "flex",
        gap: "gap.1",
        flexDirection: "column",
        overflowY: "auto",
      },
    },
    footer: {
      display: "flex",
      gap: "gap.2",
      justifyContent: "flex-end",
      alignItems: "center",
      color: "content.neutral.base.subtlest",
    },
  },
  variants: {
    size: {
      small: {
        content: {
          minHeight: "272px",
        },
        footer: {
          flexDirection: "column-reverse",
        },
      },
      medium: {
        content: {
          width: "width.m",
          minHeight: "196px",
        },
        footer: {
          flexDirection: "row",
        },
      },
    },
    backdropType: {
      light: {
        backdrop: {
          bgColor: "background.neutral.overlay.subtle",
          backdropFilter: "none",
        },
        content: {
          background: "background.neutral.base.subtlest",
        },
      },
      dark: {
        backdrop: {
          bgColor: "background.neutral.overlay.bold",
        },
      },
    },
  },
  defaultVariants: {
    size: "small",
    backdropType: "dark",
  },
});
